export default __webpack_public_path__ + "static/media/Background_00011.a5d9ffc5.png";